var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"market-status-isLeveraged"},[_c('div',{staticClass:"trade-status"},[_c('span',[_vm._v(_vm._s(_vm.marketStatusText)+" ")])]),_vm._v(" "),(_vm.showMargin)?_c('div',{staticClass:"margin-content"},[_c('span',[_vm._v(_vm._s(_vm.$t('trade.margin')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.marginText))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }